import { render } from "./PredictionHistoryId.vue?vue&type=template&id=5dd22ed4"
import script from "./PredictionHistoryId.vue?vue&type=script&lang=js"
export * from "./PredictionHistoryId.vue?vue&type=script&lang=js"

import "./PredictionHistoryId.vue?vue&type=style&index=0&id=5dd22ed4&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__